<div class="table-container">

  @if (errorMessage$ | async; as errorMessage) {
    <div class="table-container-error-message">
      <tm-error-message [friendlyError]="true" [message]="errorMessage"></tm-error-message>
      <div><button mat-flat-button color="primary" (click)="reloadData()" i18n="@@core.common.retry">Retry</button></div>
    </div>
  }

  @if (hasNoRows$ | async) {
    <div i18n="@@core.attribute-list.no-rows-found" class="table-container-empty-message">No rows found</div>
  }

  @if (hasRows$ | async) {
    <tm-attribute-list-table
      [rows]="rows$ | async"
      [columns]="columns$ | async"
      [sort]="sort$ | async"
      [filters]="filters$ | async"
      [selectedRowId]="selectedRowId$ | async"
      [canExpandRows]="canExpandRows$ | async"
      [canCheckRows]="canCheckRows$ | async"
      [checkedRows]="checkedRows$ | async"
      [featureDetails]="featureDetails$ | async"
      [loadingFeatureDetailsIds]="loadingFeatureDetailsIds$ | async"
      [showStatistics]="showStatistics$ | async"
      [statistics]="statistics$ | async"
      [pagingDataSelectedTab]="pagingDataSelectedTab$ | async"
      (selectRow)="onSelectRow($event)"
      (setSort)="onSortClick($event)"
      (setFilter)="onSetFilter($event)"
      (setAllRowsChecked)="onSetAllRowsChecked($event)"
      (setRowChecked)="onSetRowChecked($event)"
      (loadFeatureDetailsForFeature)="loadFeatureDetailsForFeature($event)"
      (loadStatisticsForColumn)="loadStatisticsForColumn($event)"
      (showStatisticsHelp)="showStatisticsHelp()"></tm-attribute-list-table>
  }

</div>
